import { NavigationProp, RouteProp, useNavigation, useRoute } from '@react-navigation/native'
import { FlatList, StyleSheet, Text, View } from 'react-native'
import { useContext, useState } from 'react'
import { useValuesCategoryTwo } from '../hooks/useValuesCategoryTwo'
import { Separator } from '../../../components/Separator'
import { TemplatePage } from '../../../components/TemplatePage'
import { ControlServicesContext } from '../../../context/SeaWater/ControlServices/ControlServicesContext'
import { useKeyboardVisibility } from '../../../hooks/useKeyboardVisibility'
import { globalStyle } from '../../../theme/global'
import { useTranslation } from 'react-i18next'
import { ControlServicesRoutes } from '../../../navigator/types'
import { Tag } from '../components'
import { Button } from '../../../components/Button'
import { NetWashingDetail } from '../../../types'
import { CategororyTwoItem } from '../components/CategororyTwoItem'
import { AlertMessage } from '../../../components/AlertMessage'
import { SuccessIcon } from '../../../components/Svg'
import { DOBRA, DOBRA_BOLD } from '../../../theme/fonts'
import { textColor } from '../../../theme/colors'

interface Navigation extends NavigationProp<ControlServicesRoutes, 'CategoryTwo'> {}
export const CategoryTwo = () => {
  const { t } = useTranslation()
  const { chores } = useContext(ControlServicesContext)
  const { navigate } = useNavigation<Navigation>()
  const route = useRoute<RouteProp<ControlServicesRoutes, 'CategoryTwo'>>()
  const { isKeyboardVisible } = useKeyboardVisibility()
  const { handleSetValue, values, deleteById } = useValuesCategoryTwo({})
  const [showAlert, setShowAlert] = useState(false)

  const handleNavigate = () => {
    const registers: Omit<NetWashingDetail, 'washingTypeName'>[] = Object.keys(values).map((x) =>
      values[x] ? values[x] : { cageCount: 0, washingTypeId: 0, m2: 0 },
    )
    setShowAlert(false)
    navigate('FinalForm', { ...route.params, netWashingDetail: registers })
  }

  const handleDisabled = (): boolean => {
    const valuesArray = Object.values(values)

    if (valuesArray.length === 0) {
      return true
    }

    return valuesArray.some(({ m2, cageCount }) => m2 === 0 || cageCount === 0)
  }

  const calculeTotal = (): string => {
    const { cage, m2 } = Object.values(values).reduce(
      (acc, item) => ({
        m2: (acc.m2 += item.m2),
        cage: (acc.cage += item.cageCount),
      }),
      { m2: 0, cage: 0 },
    )

    return `${m2} m2 | ${cage} jaulas`
  }

  return (
    <TemplatePage styleContent={{ padding: 0, marginBottom: 0 }} header title={'CONTROL SERVICES'}>
      <View style={[globalStyle.viewContainer, { padding: 24, gap: 16 }]}>
        <Tag name={route.params.centerName} />

        <FlatList
          style={{ marginVertical: 15, marginBottom: 0 }}
          data={chores[route.params.jobId] ?? []}
          ItemSeparatorComponent={() => <Separator />}
          renderItem={({ item }) => (
            <CategororyTwoItem
              item={item}
              handleSetValue={handleSetValue}
              deleteById={deleteById}
            />
          )}
          contentContainerStyle={{ gap: 24 }}
        />

        {showAlert && (
          <AlertMessage
            action={handleNavigate}
            cancelButton
            cancelLabel='Cancelar'
            actionCancelButton={() => setShowAlert(false)}
          >
            <View style={styles.headerContainer}>
              <SuccessIcon height={41} width={41} />
              <Text style={styles.title}>Resumen</Text>
            </View>
            <Separator />
            <View style={{ justifyContent: 'center', alignItems: 'center', gap: 4, marginTop: 8 }}>
              <View style={styles.containerLabel}>
                <Text style={{ color: textColor }}>Embarcación: </Text>
                <Text style={styles.label}>{route.params?.boardingName}</Text>
              </View>
              <View style={styles.containerLabel}>
                <Text style={{ color: textColor }}>Centro: </Text>
                <Text style={styles.label}>{route.params?.centerName}</Text>
              </View>

              {Object.values(values).map((item) => (
                <View key={item.washingTypeId} style={styles.containerLabel}>
                  <Text style={{ color: textColor }}>{item.washingTypeName}: </Text>
                  <Text style={styles.label}>
                    {item.m2} m2 | {item.cageCount} jaulas
                  </Text>
                </View>
              ))}

              <View style={styles.containerLabel}>
                <Text style={{ color: textColor }}>Total: </Text>
                <Text style={styles.label}>{calculeTotal()}</Text>
              </View>
            </View>
          </AlertMessage>
        )}

        {!isKeyboardVisible && (
          <Button
            onPress={() => setShowAlert(true)}
            label={t('Continuar')}
            customStyle={{ width: 'auto', marginBottom: 20 }}
            disabled={handleDisabled()}
          />
        )}
      </View>
    </TemplatePage>
  )
}

const styles = StyleSheet.create({
  headerContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
  },
  title: {
    fontFamily: DOBRA,
    fontSize: 18,
    fontWeight: '500',
    lineHeight: 22,
    textAlign: 'center',
    color: textColor,
  },

  containerLabel: {
    flexDirection: 'row',
  },

  label: {
    fontFamily: DOBRA_BOLD,
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 20,
    color: textColor,
  },
})
